// extracted by mini-css-extract-plugin
export default {"img":"MovieItem_img__tv7Fk","title":"MovieItem_title__s36vO"};